import api from '../../../axiosConfig';

// Conservar la clave durante reintentos por pérdida de respuesta, sin guardar pacientes en disco.
const pendientes = new Map();
export async function guardarLote(traslados) {
  const datos = JSON.stringify(traslados);
  if (!pendientes.has(datos)) pendientes.set(datos, crypto.randomUUID());
  try {
    const response = await api.post('/traslados/lote', { operacion_id: pendientes.get(datos), traslados });
    pendientes.delete(datos);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) pendientes.delete(datos);
    throw error;
  }
}

export async function guardarTai(payload) {
  const datos = `tai:${JSON.stringify(payload)}`;
  if (!pendientes.has(datos)) pendientes.set(datos, crypto.randomUUID());
  try {
    const response = await api.post('/tai/programar-masivo', { ...payload, operacion_id: pendientes.get(datos) });
    pendientes.delete(datos);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) pendientes.delete(datos);
    throw error;
  }
}
